<template>
  <v-container style="height: 100%"  v-if="$route.name === 'ListProgressApplications'">

    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Аттестационные дела соискателей:</span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-1 ma-1"
          label="Фамилия"
          v-model="lastName"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Имя"
          v-model="firstName"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Отчество"
          v-model="patronymic"
        >
        </v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItemsClear" color="primary" icon flat><v-icon>clear</v-icon></v-btn>
          </template>
          <span>Очистить поля ввода</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItems" color="primary" icon flat><v-icon>search</v-icon></v-btn>
          </template>
          <span>Поиск</span>
        </v-tooltip>

      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <tr class="justify-center"  @click="goPath(props.item)"  style="cursor:pointer">
                <td class="justify-center">
                  <div  v-for="item, i in props.item.lastName">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.firstName">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.patronymic">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.thesisTopic">
                    {{item.text}}
                  </div>
                </td>
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.academicDegree.name">
                      {{item.text}}
                    </div>
                  </td>

                  <td class="justify-center">{{ props.item.dissertationCouncil !== null ? props.item.dissertationCouncil.code: 'Не указан' }} </td>
                  <td class="justify-center"><v-icon>{{statusApp(0,props.item.status.status)}}</v-icon> </td>
                <td class="justify-center"><v-icon>{{statusApp(1,props.item.status.status)}} </v-icon></td>
                <td class="justify-center"><v-icon>{{statusApp(2,props.item.status.status)}}</v-icon> </td>
                </tr>

              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

  </v-container>
  <div v-else>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>


<script>

    import urls from "../../../../modules/petition/urls"
    import UserDataMixin from '../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../helper";

    export default {
        name: "ListProgressApplications",
        mixins: [UserDataMixin],
        data () {
            return {
                URL_LIST: urls.getUrl('admin|case|models|candidate_case-list', 'list'),
                URL_DELETE: urls.getUrl('admin|case|models|candidate_case-detail', 'destroy'),
                lastName: "",
                firstName: "",
                patronymic: "",
                total: 0,
                items: [],
                loading: true,
                pagination: { },
                headers: [
                    {text: 'Фамилия', sortable: true, align: 'justify-center', value: 'lastName',width: '10%'},
                    {text: 'Имя', sortable: true, align: 'justify-center', value: 'firstName',width: '10%'},
                    {text: 'Отчество', sortable: true, align: 'justify-center', value: 'patronymic',width: '10%'},
                    {text: 'Тема', sortable: true, align: 'justify-center', value: 'thesisTopic',width: '25%'},
                    {text: 'Ученая степень', sortable: true, align: 'justify-center', value: 'academicRank',width: '5%'},
                    {text: 'Диссовет', sortable: true, align: 'justify-center', value: 'dissertationCouncil',width: '5%'},
                    {text: 'Рассматривается', sortable: false, align: 'justify-center', value: 'thesisTopic',width: '5%'},
                    {text: 'ДС', sortable: false, align: 'justify-center', value: 'thesisTopic',width: '5%'},
                    {text: 'ОДС', sortable: false, align: 'justify-center', value: 'thesisTopic',width: '5%'},
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },
        mounted () {
            this.$store.commit('mainpage/changeTitle', 'Заявки в работе');
            this.getItems()
        },
        methods: {
            getItemsClear(){
              this.lastName = "";
              this.firstName = "";
              this.patronymic = "";
              this.getItems()
            },
            statusApp(type,val){

                if(type===0 && val == 0){
                    return 'done'
                }
                if(type===1 && (val > 0 && val <= 7) ){
                    return 'done'
                }
                if(type===2 && val >= 8  ){
                    return 'done'
                }
                    return 'clear'
            },
            goPath(item){
              let paramR = {id: item.id}
              if(this.$route.params.token){
                paramR = {id: item.id, token:this.$route.params.token}
              }
              this.$router.push({name:'ProgressApplication', params: paramR})
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
            getItems () {
                this.$store.commit('mainpage/changeTitle', 'Заявки в работе');
                this.loading = true

                let url = new URL(this.URL_LIST)
                let params = {};


                if(this.pagination.page !== undefined) {
                    params.page = this.pagination.page;
                    params.page_size = this.pagination.rowsPerPage;
                }
                else{
                    params.page = "1";
                    params.page_size = "10";
                }


                params.status_stage='ACTIVE'
                if(this.lastName.length !== 0)
                    params.lastName__icontains = this.lastName
                if(this.firstName.length !== 0)
                    params.firstName__icontains = this.firstName
                if(this.patronymic.length !== 0)

                    params.patronymic__icontains = this.patronymic
                url.search = new URLSearchParams(params).toString();
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
